import React, { useState } from "react";

interface FaxExtractionPromptProps {
  documentAvailable?: boolean;
  runUrl?: string;
  authenticityToken?: string;
  extractionConfigured?: boolean;
  compact?: boolean;
  mode?: "full" | "run_only";
  runLabel?: string;
  unavailableMessage?: string;
}

export default function FaxExtractionPrompt({
  documentAvailable = false,
  runUrl = "",
  authenticityToken = "",
  extractionConfigured = false,
  compact = false,
  mode = "full",
  runLabel,
  unavailableMessage = "The fax PDF is not attached on this page yet. Load the document first if you want to run the prompt against the source fax.",
}: FaxExtractionPromptProps) {
  const [running, setRunning] = useState(false);
  const runOnly = mode === "run_only";
  const buttonLabel = runLabel || (runOnly ? "Run AI Extraction" : "Run extraction");

  return (
    <div className={compact ? "flex flex-wrap items-center justify-end gap-2" : "space-y-4"}>
      {runOnly ? null : (
        <p className="text-sm text-neutral-600 dark:text-neutral-300">
          Copy a prompt for an AI model to extract one or more patients, their doctors, and dated test results from this fax.
        </p>
      )}

      {!documentAvailable ? (
        <div className="rounded-2xl border border-amber-200/80 bg-amber-50/80 p-4 text-sm text-amber-900 dark:border-amber-900/60 dark:bg-amber-950/30 dark:text-amber-100">
          {unavailableMessage}
        </div>
      ) : null}

      <div className="flex flex-wrap gap-2">
        <form
          method="post"
          action={runUrl}
          onSubmit={() => {
            setRunning(true);
          }}
        >
          <input type="hidden" name="authenticity_token" value={authenticityToken} />
          <button
            type="submit"
            className="app-button-primary"
            disabled={running || !extractionConfigured || !documentAvailable}
          >
            {running ? "Queueing" : buttonLabel}
          </button>
        </form>
      </div>

      {compact ? null : (
        <p className="text-xs text-neutral-500 dark:text-neutral-400">
          {!extractionConfigured
            ? "AI extraction is not configured for this environment."
            : runOnly
              ? "Run AI extraction for this fax."
              : "Run extraction for this fax."}
        </p>
      )}
    </div>
  );
}
